'use strict';
// TODO: Remove this module from `core-js@4` since it's replaced to module below
require('../modules/es.weak-map.constructor');



//////////////////
// WEBPACK FOOTER
// ./~/handsontable/~/core-js/modules/es.weak-map.js
// module id = 19
// module chunks = 0